import { OodleRum } from '@oodle-ai/rum'
import { getReduxTelemetrySnapshot } from './telemetryContext'

type ErrorKind =
  | 'window.error'
  | 'window.unhandledrejection'
  | 'react.errorboundary'
  | 'api.error'
  | 'sse.error'
  | 'manual'

function reportFrontendEvent(
  severity: 'error' | 'warning',
  kind: ErrorKind,
  error: unknown,
  extraAttributes?: Record<string, unknown>
): void {
  const isError = error instanceof Error

  // Callers are error handlers (axios interceptors, error boundaries); this must
  // never throw. OodleRum throws when init was skipped or its config was rejected.
  try {
    const redux = getReduxTelemetrySnapshot()

    OodleRum.trackEvent('frontend_error', {
      severity,
      error_source: kind,
      error_type: isError ? error.name : 'Error',
      error_message: isError
        ? error.message || 'Error'
        : String(error ?? 'unknown'),
      error_stack: isError ? error.stack : undefined,
      error_url: window.location.href,
      partner_id: redux?.userContext.partnerId ?? null,
      partner_user_id: redux?.userContext.partnerUserId ?? null,
      roles: redux?.userContext.roles ?? [],
      auth_type: redux?.userContext.authType ?? 'auth0',
      redux_actions: redux?.actions ?? [],
      ...extraAttributes,
    })
  } catch {
    // swallow
  }
}

export function reportFrontendError(
  kind: ErrorKind,
  error: unknown,
  extraAttributes?: Record<string, unknown>
): void {
  reportFrontendEvent('error', kind, error, extraAttributes)
}

/** Expected API failures the app already handles — see `errorDisposition`. */
export function reportFrontendWarning(
  kind: ErrorKind,
  error: unknown,
  extraAttributes?: Record<string, unknown>
): void {
  reportFrontendEvent('warning', kind, error, extraAttributes)
}
